import CoinIcon from './CoinIcon';

export default CoinIcon;
